import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'

import lang from '../lang'
import {jumpToUser, jumpToRoom} from 'src/helper/webviewFun'
export default class extends React.Component {
  state = {}

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  // shouldComponentUpdate(nextProps) {
  //   console.log('shouldComponentUpdate')
  //   // return false
  // }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  top3 = (language, list, type,myrank) => {
    return (
      <div className={`top3`}>
        {list &&
          list.length > 0 &&
          list.map((item, index) => {
            if (index < 3) {
              return (
                <div  className={`user user${index + 1}`}>
                  <img
                    // onClick={jumpToRoom.bind(this, item.gid)}
                    // className={`kuan kuan${index + 1}`}
                    // src={`/img/activity/22-09-22ksa/f${index + 1}.png`}
                  />
                  <img
                  onClick={jumpToRoom.bind(this, item.gid)}
                    className={`avatarurl avatarurl${index + 1}`}
                    src={cdn(item.logourl)}
                  />
                  <div className={`nickname nickname${index + 1}`}>{item.name ? item.name : ''}</div>
                  <div className={`did did${index + 1}`}>{item.dgid ? item.dgid : ''}</div>
                  <div className={`score score${index + 1}`}>{item.val}</div>
                </div>
              )
            }
          })}
      </div>
    )
  }

  render() {
    let { language, list, lang,myrank } = this.props
    return (
      <div className="groupList">
        <div className="listTop"></div>
        <div className="bd">
          <div className={`list ${language == 'ar' && 'arlang'}`}>
            <div className={`listuser ${language == 'ar' && 'arlang'}`}>
              {/* <div style={{ height: '0.4rem' }}></div> */}
              {this.top3(language, list)}
              <div className='list-box'>
              {list &&
                list.length > 0 &&
                list.map((item, index) => {
                  if (index > 2) {
                    return (
                      <div
                      
                        className={`${
                          'userinfo item_bg' + ((index % 2) + 1) + ' ' + (item.isMine == true ? 'item_bg3' : '')
                        } `}
                      >
                        <div className="rank">
                          {index == 0 && <img src={'/img/activity/dayiraq/img/r1.png'} />}
                          {index == 1 && <img src={'/img/activity/dayiraq/img/r2.png'} />}
                          {index == 2 && <img src={'/img/activity/dayiraq/img/r3.png'} />}
                          {index > 2 && index > 19 && '20+'}
                          {index > 2 && index < 20 && index + 1}
                        </div>
                        <div className={`userlogo`} title={item.gid} onClick={jumpToRoom.bind(this, item.gid)}>
                          <img
                          onClick={jumpToRoom.bind(this, item.gid)}
                            src={cdn(item.logourl)}
                          />
                        </div>
                        <div style={{ width: '0.3rem' }}></div>
                        <div className="nickname">
                          <div className={`${'nickname1'}`}>{item ? item.name : ''}</div>
                          <div className={`${'nickname2'}`}>ID: {item ? item.dgid : ''}</div>
                        </div>
                        <div className="itemRight">
                          <div className="scoreicon">
                            <div className="score">{item.val}</div>
                          </div>
                        </div>
                      </div>
                    )
                  }
                })}

                  <div  className="userinfo item_bg7 myrank">
                        <div className="rank">
                          {myrank.rank}
                        </div>
                        <div className={`userlogo`} title={myrank.gid} >
                          <img
                          onClick={jumpToRoom.bind(this, myrank.gid)}
                            src={cdn(myrank.logourl)}
                          />
                        </div>
                        <div style={{ width: '0.3rem' }}></div>
                        <div className="nickname">
                          <div className={`${'nickname1'}`}>{myrank ? myrank.name : ''}</div>
                          <div className={`${'nickname2'}`}>
                            ID: {myrank ? myrank.dgid : ''}
                            {myrank.isMine}
                          </div>
                        </div>
                        <div className="itemRight">
                          <div className="scoreicon">
                            <div className="score">{myrank.val}</div>
                          </div>
                        </div>
                    </div>

                </div>
            </div>
          </div>
        </div>
        <div className="listBottom">
          {/* <img src="/img/activity/22-09-22ksa/b3.png" /> */}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/202408tr/GroupList/index.js